import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getSubCategories, excludeDeprecated, getSubCategory } from 'common/ducks/categories';
import { fetchReviews, clearReviews } from 'marketing/ducks';
import Reviews from 'marketing/components/reviews';

const mapStateToProps = ({ marketing, categories }, { location }) => {
  const currentCategories = excludeDeprecated(categories.data)
  const oneToOneSubcats = getSubCategories({
    data: currentCategories.filter(c => c.is_one_to_one)
  });
  const initialSubcat = getSubCategory({ data: currentCategories }, location.query.sub_category);

  return {
    count: marketing.reviewCount,
    items: marketing.reviews,
    fetching: marketing.fetchingReviews,
    initialSubcat: initialSubcat? initialSubcat.id.toString() : "all",
    oneToOneSubcats
  };
}

export default withRouter(connect(mapStateToProps, {
  fetch: fetchReviews,
  clear: clearReviews
})(Reviews));



// WEBPACK FOOTER //
// ./marketing/containers/reviews.js